import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useNavigate, useOutletContext } from 'react-router-dom';
import Sortable from 'sortablejs';
//api
import { deleteFaq, reorderFaq } from 'api/faqs';
import { getAllFaqs } from 'api/pathForHook/faqs';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import Button from 'components/backoffice/buttonCustom';
import Title from 'components/backoffice/texts/title';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import { usePermissions } from 'components/backoffice/PermissionsContext';
import FiltersTableFaqs from './FiltersTableFaqs';

const Faqs = () => {
  const userPermissions = usePermissions();
  const navigate = useNavigate();
  const [faqs, setFaqs] = useState([]);
  const [faq, setfaq] = useState({});
  const [page, setPage] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [evt, setEvt] = useState();
  const [active, setActive] = useState('ninguno');
  const [formFilter, setFormFilter] = useState({
    active: '',
    search: '',
  });
  const [responseInfo, setResponseInfo] = useState({});
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()

  const colsFaqs = [
    t('faqs.question'),
    t('faqs.answer'),
    t('faqs.order'),
    t('activo'),
    t('actions')
  ];

  const { fetchData, stateData, loading } = useHandleSearch();

  const getFaqs = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        search: formFilter.search || '',
        active: formFilter.active || '',
        fields: 'id,question,answer,order,active'
      }
      await fetchData(getAllFaqs(), payload);
    } catch (error) {
      console.error(error);
    }
  };


  const editByReorderFaq = async (values) => {
    const { status } = await reorderFaq({ faqs: values });
    if (status === 200) {
      getFaqs();
    } else {
      toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
    }
  };

  useEffect(() => {
    Sortable.create(document.getElementById('items-container'), {
      onEnd: (event) => {
        setEvt(event);
      },
    });
  }, []);

  useEffect(() => {
    setTitle(t('faqs.faqs'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setFaqs(results);
      setResponseInfo({ errors, totalPages, noResults });
    } else {
      setFaqs(null);
      setResponseInfo({ errors });
    }
  }, [stateData])

  useEffect(() => {
    getFaqs();
  }, [page, formFilter]);

  useEffect(() => {
    if (evt) {
      const { oldIndex, newIndex, item } = evt;
      const dragged_id = parseInt(item.getAttribute('data-id'), 10);
      let faqsOrdered = [];
      if (newIndex > oldIndex) {
        faqsOrdered = faqs.map((faqItem) => {
          let obj = { ...faqItem };
          if (faqItem.order > oldIndex && faqItem.order <= newIndex) obj.order -= 1;
          return obj;
        });
      } else {
        faqsOrdered = faqs.map((faqItem) => {
          let obj = { ...faqItem };
          if (faqItem.order < oldIndex && faqItem.order >= newIndex) obj.order += 1;
          return obj;
        });
      }
      const newOrderEl = faqsOrdered.find((obj) => obj.id === dragged_id);
      newOrderEl.order = newIndex;
      editByReorderFaq(faqsOrdered);
    }
  }, [evt]);

  const onDelete = async () => {
    const { status } = await deleteFaq(faq.id);
    if (status === 204) {
      toast.success(t('eliminadocorrectamente'));
      setFormFilter({
        search: '',
        active: 'ninguno',
      });
      setShowDeleteModal(false);
    } else {
      toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
    }
  };

  const openModalDelete = (object) => {
    setShowDeleteModal(true);
    setfaq(object);
  };

  const handleClear = () => {
    setFormFilter({
      search: '',
      active: 'ninguno',
    });
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }));
  };

  const handleCreate = () => {
    navigate('/intranet/faqs/create');
  };

  const handleEdit = (id) => {
    navigate(`/intranet/faqs/edit/${id}`);
  };

  return (
    <div className="d-lg-grid">
      <Title text={t('faqs.faqs')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col md={9} xs={12} className="d-flex text-start">
          <FiltersTableFaqs
            formFilter={formFilter}
            handleClear={handleClear}
            setFormFilter={setFormFilter}
            t={t}
            page={page}
            setPage={setPage}
          />
        </Col>
        <Col md={3} xs={12} className="d-flex text-end align-bottom p-md-0 justify-content-end pt-5 pt-md-0">
          {userPermissions.includes('faq.__add') && (
            <Button color="primary" onClick={handleCreate}>
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsFaqs}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {faqs
            ?.sort((a, b) => a.order - b.order)
            .map((f) => {
              return (
                <tr key={f.id} data-id={f.id} className="draggable-row">
                  <td className="text-light">{f.question}</td>
                  <td className="text-light" dangerouslySetInnerHTML={{ __html: f.answer }} />
                  <td className="text-light">{f.order}</td>
                  <td className="text-light">{f.active === false ? 'No' : 'Si'}</td>
                  <td className="text-light item-dropdown text-end">
                    <DropdownIcons
                      idItem={f.id}
                      handleDelete={userPermissions.includes('faq.__delete') && (() => openModalDelete(f))}
                      handleEdit={userPermissions.includes('faq.__modify') && (() => handleEdit(f.id))}
                    />
                  </td>
                </tr>
              );
            })}
        </CustomTable>
      </div>
      <DeleteModalCustom
        openModal={showDeleteModal}
        setOpenModal={setShowDeleteModal}
        handleDelete={onDelete}
        deleteTitle={t('deletefaq')}
        beforeTitle={t('faqs.faqs')}
      />
    </div>
  );
};

export default Faqs;
